import React, {useContext } from "react";
import { AppContext } from '../AppContext';
import { config, formatPercent } from '../helpers/constants';
import { makeStyles } from '@material-ui/styles';

export default function ResultOverview(props) {
    const useStyles = makeStyles(theme => ({
        resultReportPercent: {
            fontSize: "12px",
            display: "block",
            marginTop: "-21px",
        },
        centerAlign: {
            textAlign: "center"
        }, 
    }));
    const state = useContext(AppContext);
    const classes = useStyles(state);
    const percent = formatPercent(Math.max(0, Math.min(props.value, 100)));

    return (
        <div>
            {!props.navigateOnClick ? 
            <div className={classes.centerAlign}>
                <img
                    className={classes.image}
                    src={`${config.backendUrl}button?percent=${(percent && parseInt(percent)) || 0}&size=0`} alt="Result"
                />
                {percent ? <span className={classes.resultReportPercent}>{percent}%</span> : ''}
            </div> :
            <div className={classes.centerAlign}>
                <img 
                    onClick={(e) => props.onSelectId(props.row.original.Id, e)} 
                    src={`${config.backendUrl}button?percent=${(percent && parseInt(percent)) || 0}&size=0`} alt="result" />
                {percent ? <span onClick={(e) => props.onSelectId(props.row.original.Id, e)} className={classes.resultReportPercent}>{percent}%</span>: ''}
            </div>
            }
        </div>
    )
}